import { skipToken, useQuery } from '@tanstack/react-query'
import { optionGetters } from '../../utils/dataCollection/optionsGetters'
import { queryKeys } from './queryKeys'

type FieldOption = { id: string | number; label: string; value?: string | number }

// The registry is dispatched by the getter name a form definition stores, so every getter is
// called through the one argument shape the dynamic forms pass.
type OptionGetter = (args: { values: unknown; farmId?: string }) => Promise<FieldOption[]>

type OptionsFromField = {
  getterFunction: string
  sourceField?: string
}

// The message reaches the user through the global error snackbar.
const findOptionGetter = (getterFunction: string): OptionGetter => {
  const getter = (optionGetters as Record<string, OptionGetter | undefined>)[getterFunction]
  if (!getter) throw new Error(`El formulario pide opciones a "${getterFunction}", que no existe.`)
  return getter
}

export const useFieldOptions = ({
  optionsFromField,
  sourceValues,
  farmId,
}: {
  optionsFromField: OptionsFromField | undefined
  sourceValues: unknown
  farmId: string | undefined
}) => {
  const getterFunction = optionsFromField?.getterFunction

  return useQuery({
    queryKey: queryKeys.fieldOptions(getterFunction, farmId, sourceValues),
    queryFn: getterFunction
      ? () => findOptionGetter(getterFunction)({ values: sourceValues, farmId })
      : skipToken,
    // The getters' entity reads already retry through the shared client; retrying here would
    // repeat them and hold the field on its skeleton.
    retry: false,
    // Entity writes bust their own keys, not this derived entry, so it re-derives on every mount.
    staleTime: 0,
  })
}
